module.exports = __webpack_public_path__ + "static/media/icon_option.12f46fa1.svg";